/* eslint-disable no-shadow */
/* eslint-disable */
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, Tooltip } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import moment from 'moment';
import styles from './CreditNotePage.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../Components/Loaders';
import ListTable from '../../Components/ListTable/ListTable';
import ImageModal from '../../Components/Modals/ImageModal/ImageModal';
import myMachineService from '../../Services/AssetServices/myMachine.service';
// import { ListModal } from '../../../Components/Modals';
import { modalActions } from '../../Actions';
import { notificationServices } from '../../Services';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { PaymentModal } from '../../Components/Modals/PaymentModal';
import { useAuth } from '../../Components/Auth/Login/auth';
import { urls } from '../../Constants';
import { TransactionsModal } from '../../Components/Modals/TransactionsModal';
import { capitalizeFirstLetter, filtersInfoChip, getActionColumn, getFileName, useQuery } from '../../Helpers';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import { Filter, RefreshCcw } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { format } from 'date-fns';
import GlobalSearch from '@/Components/globalSearch/search';

const TABLE_COLUMNS = [
	{
		title: 'type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Destination Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sourcing Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Debit/Credit Note Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Balance Amount',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMN = [
	{
		title: 'View Applied On',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'View',
		config: {
			type: 'DATA',
		},
	},
];

const ADDITIONAL_COLUMN = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];
const statusList = [
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
	{
		id: 'PAID',
		title: 'PAID',
	},
	{
		id: 'UNPAID',
		title: 'UNPAID',
	},
	{
		id: 'PARTIALLY_PAID',
		title: 'PARTIALLY PAID',
	},
	{
		id: 'APPROVAL_PENDING_MANAGER',
		title: 'APPROVAL PENDING MANAGER',
	},
	{
		id: 'APPROVAL_PENDING_FINANCE',
		title: 'APPROVAL PENDING FINANCE',
	},
];

const COLMAP = {
	type: 'subType',
	Vendor: 'vendorName',
	'Destination Store': 'storeName',
	'Sourcing Store': 'fromStoreName',
	'Order id': 'orderId',
	'Client Bill. Id': 'parentTransactionRecord.clientTransactionId',
	'Client Id': 'clientTransactionId',
	'Debit/Credit Note Date': 'transactionDate',
	Status: 'transactionStatus',
	'Total Amount': 'finalTransactionAmount',
	'Balance Amount': 'currentAmount',
};

function CreditNotePage({
	userPermissions,
	createPath,
	togglePOItemsModal,
	creditPageType,
	navState,
	toggleAlert,
	toggleTransactionsModal,
	userList,
	fetchUserList,
	toggleFiltersDrawer,
}) {
	const params = useQuery();
	let poId = params.get('poId') ? Number(params.get('poId')) : undefined;
	let clientPOId = params.get('clientPoId');
	const isCreditsPage = creditPageType === 'credits';
	// const navRequisites =
	// navState?.[isCreditsPage ? urls.PURCHASE_ORDERS : urls.SALES_ORDERS]
	// ?.requisites ?? [];
	// const navSelectedStore = navRequisites?.find((ele) => {
	// return ele?.type === 'store';
	// });
	const history = useHistory();
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('CXO Office');
	const [isloading, setIsloading] = useState(false);
	const [creditNoteList, setCreditNoteList] = useState([]);
	const [update, setUpdate] = useState(-1);
	const [externalFilters, setExternalFilters] = useState([]);
	const [filters, setFilters] = useState({});
	const [search, setSearch] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);

	useEffect(() => {
		if (poId) {
			setUpdate((prev) => {
				return prev + 1;
			});
			const poFilterExternal = {
				id: poId,
				type: 'orderId',
				title: `Order Id: ${clientPOId}`,
				removable: true,
				handleRemove: () => {
					params.delete('poId');
					params.delete('clientPoId');
					poId = null;
					clientPOId = null;
					setUpdate((prev) => {
						return prev + 1;
					});
					setExternalFilters((prev) => {
						return prev?.filter((ele) => {
							return ele?.type !== 'orderId';
						});
					});
					history.replace({
						search: params.toString(),
					});
				},
			};
			setExternalFilters((prev) => {
				const exists = prev?.find((ele) => {
					return ele?.type === 'orderId';
				});
				if (exists) {
					if (exists?.id !== poId) {
						return prev?.map((ele) => {
							if (ele?.type === 'orderId') {
								return poFilterExternal;
							}
							return ele;
						});
					}
					return prev;
				}
				return [...prev, poFilterExternal];
			});
		}
	}, [poId]);

	const handleListFetch = async (requestOptions, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setIsloading(true);
		setFilters(requestOptions);
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters: {
								vendors: requestOptions?.vendors?.id,
								storeId: requestOptions?.store?.id,
								status: requestOptions?.status,
								orderId: poId,
								...(!poId && {
									dateRangeFilter: {
										from: moment(
											requestOptions?.dateRange?.from
										).format('YYYY-MM-DD'),
										to: moment(
											requestOptions?.dateRange?.to
										).format('YYYY-MM-DD'),
									},
								}),
							},
							type: 'CREDIT',
							transactionItems: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				// setSelectedStore(store);
				setCreditNoteList(responseData?.data);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			handleListFetch(filters);
		}
	}, [search?.searchValue]);

	const idSearch = async () => {
		setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							search: {
								...(search?.value === 'clientId' && {
									clientTransactionId: Number(search?.searchValue),
								}),
								...(search?.value === 'orderId' && {
									orderId: Number(search?.searchValue),
								}),
							},
							type: 'CREDIT',
							transactionItems: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				// setSelectedStore(store);
				setCreditNoteList(responseData?.data);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const handleCancelCredit = async (item) => {
		setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: item?.id,
					},
					data: {
						status: 'CANCELLED',
						type: 'CREDIT',
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const handleAppliedOnBills = async (credItem) => {
		try {
			const response =
				await inventoryAnalyticsServices.getTransactionRecord({
					params: {
						transactionId: credItem?.id,
						type: 'CREDIT',
					},
				});
			if (response?.statusCode === 200) {
				toggleTransactionsModal(true, {
					listData: response?.data?.PAYMENTS?.map((ele) => {
						return {
							...ele,
							creditUsedAmount: ele?.txnUsedAmount,
						};
					}),
					transactionType: 'PAYMENTS',
					heading: `#${response?.data?.clientTransactionId ??
						response?.data?.id
						}- Debit Applied on Payments`,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleApproveClick = (item) => {
		const noteType = item?.subType?.split('_')?.join(' ');
		togglePOItemsModal(true, {
			heading: `${capitalizeFirstLetter(noteType)} of #${item?.clientTransactionId ?? item?.id
				}`,
			...item,
			isApprove: true,
			advanceBill: true,
			approvalText: `I have reviewed and checked the ${item?.subType === 'DEBIT_NOTE' ? 'Debit Note' : 'Credit Note'
				}.`,
			showTotal: false,
			showPdf: true,
			showPoDetails: true,
			width: '90%',
			height: '90%',
			transactionData: {
				'Client ID': item?.clientTransactionId,
				Status: item?.transactionStatus?.split('_')?.join(' '),
				'Destination Store': item?.storeName,
				'Sourcing Store': item?.fromStoreName,
				'Payment Type': item?.extraData?.paymentType,
				// 'Payment Mode': item?.extraData?.paymentMode,
				Vendor: item?.vendorName,
				'Transaction Amount': `\u20B9${item?.finalTransactionAmount}`,
				'Transaction Date': moment(item?.transactionDate)?.format(
					'DD-MM-YYYY'
				),
			},
			excludedColumns: [
				'Category Name',
				'Ordered Quantity',
				'Returned Quantity',
				'Packaged',
				'Received',
				'Dispatched',
				'Fulfilled',
				'Returned',
				'From Process',
				'PO Id',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty',
			],
		});
	};

	const SPECIAL_ITEMS = {
		type: (typeVal) => {
			const withoutUnderscore = typeVal?.split('_')?.join(' ');
			return (
				<p>{typeVal ? withoutUnderscore : '-'}</p>
			);
		},
		'View Applied On': (id) => {
			const credItem = creditNoteList?.find((ele) => {
				return id === ele?.id;
			});
			return (
				<Visibility
					className={`${styles['action-btn']} ${styles.view}`}
					onClick={() => {
						handleAppliedOnBills(credItem);
					}}
				>
					Cancel
				</Visibility>
			);
		},
		Actions: (id) => {
			const credItem = creditNoteList?.find((ele) => {
				return id === ele?.id;
			});
			return (
				<div className={styles.btns}>
					{(
						credItem?.transactionStatus ===
						'APPROVAL_PENDING_MANAGER' && levels.includes(level) && (isInternal || Object?.values?.(userRolesDict ?? {}).includes('Procurement'))) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(credItem);
								// handleApproval('APPROVAL_PENDING_MANAGER', id);
							}}
							fullWidth
						>
							Manager Approval
						</Button>
					) : null}
					{(credItem?.transactionStatus === 'APPROVAL_PENDING_FINANCE' && levels.includes(level) && (isInternal || Object?.values?.(userRolesDict ?? {}).includes('Finance'))) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(credItem);
								// handleApproval('APPROVAL_PENDING_FINANCE', id);
							}}
							fullWidth
						>
							Finance Approval
						</Button>
					) : null}
					{credItem?.transactionStatus !== 'CANCELLED' &&
						credItem?.transactionStatus !==
						'APPROVAL_PENDING_FINANCE' &&
						credItem?.transactionStatus !== 'REJECTED' &&
						credItem?.finalTransactionAmount ===
						credItem?.currentAmount ? (
						<Button
							onClick={() => {
								toggleAlert(true, {
									heading: `Cancel Payment ${credItem?.clientTransactionId ??
										credItem?.id
										}`,
									handleConfirm: () => {
										handleCancelCredit(credItem);
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Cancel Debit: ${credItem?.clientTransactionId || ''
										}?`,
									width: '28rem',
								});
							}}
							variant='outlined'
							fullWidth
							color='error'
						>
							Cancel
						</Button>
					) : (
						'-'
					)}
				</div>
			);
		},
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	const handleViewClick = (item) => {
		const noteType = item?.subType?.split('_')?.join(' ');
		togglePOItemsModal(true, {
			width: '90%',
			height: '90%',
			showPoDetails: true,
			heading: `${capitalizeFirstLetter(noteType)} of #${item?.clientInvoiceId ?? item?.id
				}`,
			...item,
			transactionData: {
				'Client ID': item?.clientTransactionId ?? '-',
				'Order ID': item?.orderId,
				'Vendor Name': item?.vendorName ?? '',
				Store: item?.storeName,
				[`${capitalizeFirstLetter(noteType)} Date`]: moment(
					item?.createdAt
				).format('YYYY-MM-DD'),
				[`${capitalizeFirstLetter(noteType)} Amount`]:
					item?.finalTransactionAmount,
			},
			excludedColumns: [
				'Packaged',
				'Ordered Quantity',
				'Dispatched',
				'Received',
				'Returned Quantity',
				'Fulfilled',
				'From Process',
				'PO Id',
				'Returned',
				// 'Quantity',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty',
			],
		});
	};

	const handleStatus = async (data, rejectionReason, type) => {
		let status = '';
		if (data?.transactionStatus === 'APPROVAL_PENDING_MANAGER') {
			status = 'APPROVAL_PENDING_FINANCE';
		}
		if (data?.transactionStatus === 'APPROVAL_PENDING_FINANCE') {
			status = 'UNPAID';
		}
		if (type === 'rejection') {
			status = 'REJECTED';
		}
		if (type === 'cancelation') {
			status = 'CANCELLED';
		}
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: data?.id,
					},
					data: {
						status,
						...(type === 'rejection' && {
							rejectionReason,
						}),
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
				togglePOItemsModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const filterInfo = {
		header: {
			store: false,
			statusAndTypes: false,
			date: false,
		},
		filteredStore: {
			show: true,
			text: 'Billed at',
		},
		vendor: {
			show: true,
			text: 'Billed by (Vendor)',
		},
		status: {
			show: true,
			text: 'Note Status',
		},
		dateRangeOnly: {
			show: true,
			text: 'Debit/Credit Note Date',
		}
	}

	const handleExportData = () => {
		const headers = Object.keys(COLMAP);

		const rows = creditNoteList?.map(item => {
			return headers.map(header => {
				const value = item[COLMAP[header]];
				return value || '-';
			});
		}).filter(row => {
			if (!isCreditsPage) {
				return row.title !== 'Client Bill. Id';
			}
			return true;
		});
		const csvData = [headers, ...rows];

		const filename = getFileName(filters);

		// Download CSV
		const csvContent = csvData.map(row => row.join(',')).join('\n');
		const csvFile = new Blob([csvContent], { type: 'text/csv' });

		// Create download link
		const downloadLink = document.createElement('a');
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = 'none';

		// Add to DOM, trigger click, then clean up
		document.body.appendChild(downloadLink);
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
		document.body.removeChild(downloadLink);
	};

	const dropDownItems = [
		{
			label: 'Client ID',
			value: 'clientId',
			placeholder: 'Search by Client ID',
			getData: true,
		},
		{
			label: 'Order ID',
			value: 'orderId',
			placeholder: 'Search by Order ID',
			getData: true,
		},
	];

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			idSearch();
		}
	};

	const exportInfo = {
		showExportBtn: true,
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<POItemsModal
				handleConfirm={handleStatus}
				handleReject={(data, rejectionReason) => {
					handleStatus(data, rejectionReason, 'rejection');
				}}
			/>
			<TransactionsModal />
			<div className={styles.header}>
				<ImagesFinder
					onSubmit={handleListFetch}
					update={update}
					statusList={statusList}
					externalFilters={externalFilters}
					filtersInfo={filterInfo}
					exportInfo={exportInfo}
				/>
				<div className='flex flex-col gap-2 w-full'>
					<div className='flex justify-between m-4 w-full items-center'>
						<span className='font-bold text-[16px]'>Debit Notes</span>
					</div>
					<div className='flex gap-4 w-full justify-start items-center py-1'>
						<div className='w-[82%]'>
							<GlobalSearch
								dropDownOptions={dropDownItems}
								setSelectedValue={setSearch}
								handleValue={handleCall}
								isRefresh={isRefresh}
							/>
						</div>
						<Tooltip title='Refresh Debit Notes'>
							<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
								handleListFetch(filters, true);
							}} />
						</Tooltip>
						<Button
							onClick={() => {
								toggleFiltersDrawer(true, {
									exportFrontend: true,
									handleExportFrontend: handleExportData,
								});
							}}
							className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
						>
							<span className='text-nowrap capitalize'>Filter & Export</span>
							<Filter className='size-4' />
						</Button>
					</div>
				</div>
			</div>
			{filtersInfoChip(filterInfo, filters)}
			<ListTable
				colMap={COLMAP}
				columns={TABLE_COLUMNS?.filter((ele) => {
					if (!isCreditsPage) {
						return ele?.title !== 'Client Bill. Id';
					}
					return true;
				})}
				data={creditNoteList}
				actions={getActionColumn(BASE_COLUMN, ADDITIONAL_COLUMN, level)}
				special={SPECIAL_ITEMS}
				handleViewClick={handleViewClick}
				allowExport={false}
				showBtnContainer={false}
			/>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { userList } = state.auth;
	return {
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	togglePOItemsModal: modalActions.togglePOItemsModal,
	togglePaymentModal: modalActions.togglePaymentModal,
	toggleTransactionsModal: modalActions.toggleTransactionsModal,
	toggleAlert: modalActions.toggleAlert,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditNotePage);
